module.exports = __webpack_public_path__ + "img/emptyitem.087e6581.png";